/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useCallback, useEffect, useState } from "react";
import { useShowError } from "~/components/Error/useShowError";
import { useAxios } from "~/tools";

const useAPIData = <Type>(
  url: string,
  getter: (respData: any) => Type,
  defaultVal: Type
): [Type, boolean, () => Promise<void>] => {
  const [data, setData] = useState<Type>(defaultVal);
  const [loading, setLoading] = useState(false);

  const { Axios } = useAxios();
  const { showError } = useShowError();

  const fetchData = useCallback(async () => {
    setLoading(true);
    try {
      const { data: apiData } = await Axios().get(url);
      setData(getter(apiData));
    } catch (e) {
      showError(e.response);
    }
    setLoading(false);
  }, [Axios, url, showError]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data, loading, fetchData];
};

export { useAPIData };
